import { dispatchSkeletonAppEvent } from '../../../../../utils/customEvents';
import { playerEventsStorage } from '../../storages';

export function handleLoadMeta() {
  dispatchSkeletonAppEvent();
  playerEventsStorage.setIsLoadMeta(true);
}
